module.exports = __webpack_public_path__ + "static/img/jq.5505ef7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jq.png
// module id = xWK1
// module chunks = 5